// @flow
import * as React from 'react';

import { useToast } from '@locus-taxy/neo-ui';

import withErrorBoundary from 'common/components/core/errors/ErrorBoundary';
import useEffectOnce from 'common/hooks/useEffectOnce';

type Props = {
    errorTitle: string,
    errorContent: string
};

const ErrorScreen = ({ errorTitle, errorContent }: Props): React.Node => {
    const { showToast } = useToast();

    useEffectOnce(() => {
        showToast({
            title: errorTitle,
            content: errorContent,
            palette: 'danger'
        });
    });

    return null;
};

const ToastErrorBoundary = withErrorBoundary({
    ErrorScreen,
    options: {
        disableErrorResetOnRouteChange: true
    }
})();

export default ToastErrorBoundary;
